<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">举报时间</span>
        <el-date-picker
            v-model="date"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">内容类型</span>
        <el-select v-model="content" class="w150" placeholder="不限" clearable>
          <el-option v-for="(item, index) in contentList" :key="index" :label="item.name"
                     :value="item.id"/>
        </el-select>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">状态</span>
        <el-select v-model="status" class="w150" placeholder="不限" clearable>
          <el-option v-for="(item, index) in statusList" :key="index" :label="item.name" :value="item.id"/>
        </el-select>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">举报内容</span>
        <el-select v-model="type" class="w150" placeholder="不限" clearable>
          <el-option v-for="(item, index) in typeList" :key="index" :label="item.complainTypeName"
                     :value="item.complainTypeId"/>
        </el-select>
      </div>
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getReportPageFn()">
          搜索
        </el-button>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="typeModal = true">
          举报内容设置
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="referUserName" label="发布者"></el-table-column>
      <el-table-column align="center" prop="title" label="内容标题"></el-table-column>
      <el-table-column align="center" prop="referType.desc" label="内容类型"></el-table-column>
      <el-table-column align="center" prop="referCreateTime" label="创建时间"></el-table-column>
      <el-table-column align="center" prop="complainUserName" label="举报人"></el-table-column>
      <el-table-column align="center" prop="complainTypeName" label="举报内容"></el-table-column>
      <el-table-column align="center" prop="createTime" label="举报时间"></el-table-column>
      <el-table-column align="center" prop="status.desc" label="状态"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a" @click="auditBtn(1, row.complainRecordsId)">查看</a>
          <a class="glob-a" v-if="row.status ? row.status.name === 'UNDEAL' : false"
             @click="auditBtn(2, row.complainRecordsId)">处理</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 审核 -->
    <el-dialog :title="auditData.show == 2 ? '审核' : '查看'" :visible.sync="auditData.modal" width="800px">
      <el-form label-width="120px">
        <el-form-item label="内容类型：">
          {{auditData.data.referType && auditData.data.referType.desc}}
        </el-form-item>
        <el-form-item label="内容标题：" v-if="auditData.data.referType && auditData.data.referType.name != 'COMMENT'">
          {{auditData.data.title}}
        </el-form-item>
        <el-form-item label="内容详情：">
          <div class="mb10">
            {{auditData.data.content}}
          </div>
          <div class="mb10" v-if="auditData.data.videoUrl">
            <video :src="auditData.data.videoUrl" width="350" height="200"></video>
          </div>
          <div class="mb10" v-if="auditData.data.imgList && auditData.data.imgList.length">
            <show-img v-for="(item,index) in auditData.data.imgList" :key="index" :value="item" class="mr10"/>
          </div>
        </el-form-item>
        <el-form-item label="举报原因：">
          {{auditData.data.complainTypeName}}
        </el-form-item>
        <el-form-item label="处理意见：">
          <el-row v-if="auditData.show === 2">
            <el-col :span="6">
              <el-radio v-model="auditData.type" label="DEAL">
                无需处理
              </el-radio>
            </el-col>
            <el-col :span="12">
              <el-radio v-model="auditData.type" label="REMOVE">
                下架
              </el-radio>

              <el-input
                  class="mt10 w400"
                  resize="none"
                  type="textarea"
                  :rows="4"
                  maxlength="100"
                  show-word-limit
                  v-model="auditData.content"
                  :disabled="auditData.type === 'DEAL'"
              />
            </el-col>
          </el-row>
          <p v-else>
            {{auditData.data.remark}}
          </p>
        </el-form-item>
      </el-form>

      <div slot="footer" v-if="auditData.show === 2">
        <el-button @click="auditData.modal = false">取 消</el-button>
        <el-button type="primary" @click="auditSave">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 举报内容设置 -->
    <el-dialog title="举报内容设置" :visible.sync="typeModal" width="500px">
      <div>
        <el-button type="primary" @click="typeBtn(1)">新增</el-button>
      </div>
      <ul class="type-ul">
        <li class="type-li" v-for="(item, index) in typeList" :key="index">
          <p>{{item.complainTypeName}}</p>
          <div>
            <a class="glob-a" @click="typeBtn(2, item)">编辑</a>
            <a class="glob-a" @click="typeBtn(3, item)">删除</a>
          </div>
        </li>
      </ul>
    </el-dialog>
  </div>
</template>

<script>
  import ShowImg from '@/components/ShowImg'

  import {
    getReportPage,
    getReportContentTypeList,
    addReportContentType,
    setReportContentType,
    delReportContentType,
    getReportMsg,
    setReport
  } from '@/api'

  export default {
    name: 'ReportList',
    components: {ShowImg},
    data () {
      return {
        date: [],
        type: '',
        typeList: [],
        content: '',
        contentList: [
          {name: '广告', id: 'AD'},
          {name: '资讯', id: 'INFO'},
          {name: '视频', id: 'VIDEO'},
        ],
        status: '',
        statusList: [
          {name: '未处理', id: 'UNDEAL'},
          {name: '已处理', id: 'DEAL'}
        ],
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        auditData: {
          modal: false,
          show: 1,
          data: {},
          type: 'DEAL',
          content: ''
        },
        typeModal: false,
      }
    },
    created () {
      this.getReportPageFn()
      this.getReportContentTypeListFn()
    },
    methods: {
      auditSave () {
        setReport({
          complainRecordsId: this.auditData.data.complainRecordsId,
          status: this.auditData.type,
          remark: this.auditData.type === 'REMOVE' ? this.auditData.content : ''
        }).then(res => {
          this.$message.success(res.data)
          this.auditData.modal = false
          this.getReportPageFn()
        })
      },
      // t: 1查看  2处理
      auditBtn (t, id) {
        getReportMsg(id).then(res => {
          this.auditData = {
            modal: true,
            show: t,
            data: res.data,
            type: 'DEAL',
            content: ''
          }
        })
      },
      typeBtn (t, row) {
        switch (t) {
          case 1:
            this.$prompt('请输入类型名称', '新增', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPattern: /\S/,
              inputPlaceholder: '请输入',
              inputErrorMessage: '请输入'
            }).then(({value}) => {
              addReportContentType({complainTypeName: value}).then(res => {
                this.$message.success(res.data)
                this.getReportContentTypeListFn()
              })
            }).catch(() => {
            })
            break
          case 2:
            this.$prompt('请输入类型名称', '修改', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPattern: /\S/,
              inputValue: row.complainTypeName,
              inputPlaceholder: '请输入',
              inputErrorMessage: '请输入'
            }).then(({value}) => {
              setReportContentType({
                complainTypeId: row.complainTypeId,
                complainTypeName: value
              }).then(res => {
                this.$message.success(res.data)
                this.getReportContentTypeListFn()
              })
            }).catch(() => {
            })
            break
          case 3:
            this.$confirm('确认删除吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              delReportContentType(row.complainTypeId).then(res => {
                this.$message.success(res.data)
                this.getReportContentTypeListFn()
              })
            }).catch(() => {
            })
            break
        }
      },
      getReportPageFn () {
        this.tableLoading = true
        getReportPage({
          referType: this.content,
          complainTypeId: this.type,
          status: this.status,
          pageNum: this.pages.page,
          startTime: this.date && this.date.length ? this.date[0] : '',
          endTime: this.date && this.date.length > 1 ? this.date[1] : '',
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getReportPageFn()
      },
      getReportContentTypeListFn () {
        getReportContentTypeList().then(res => {
          this.typeList = res.data
        })
      }
    }
  }
</script>

<style scoped>
  .type-ul {
    margin-top: 10px;
    max-height: 400px;
    overflow: auto;
  }

  .type-li {
    display: flex;
    align-items: center;
    line-height: 40px;
    border-bottom: 1px solid #d0d3da;
  }

  .type-li p {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
